module.exports = __webpack_public_path__ + "img/workNewsCover4.8d99ac1d.png";